import { PaletteOptions } from "@mui/material/styles";

import { colors } from "./colors";

export const palette: PaletteOptions = {
  background: {
    default: colors.light,
  },
  common: {
    black: colors.dark,
    white: colors.white,
  },
  primary: {
    main: colors.primary,
    contrastText: colors.white,
  },
  secondary: {
    main: colors.secondary,
    contrastText: colors.white,
  },
  success: {
    main: colors.primary,
    contrastText: colors.white,
  },
  warning: {
    main: colors.secondary,
    contrastText: colors.white,
  },
  info: {
    main: colors.info,
    contrastText: colors.white,
  },
  error: {
    main: colors.error,
    contrastText: colors.white,
  },
  action: {
    disabled: colors.white,
    disabledBackground: colors.grey,
  },
  text: {
    primary: colors.dark,
    secondary: colors.grey,
  },
};
